export default __webpack_public_path__ + "static/media/parkingmap2.859a5232.png";